const I = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDggNzIiPgo8cGF0aCBkPSJNMCwwSDEwOFY3MkgweiIgZmlsbD0iIzAwMzc4NyIvPgo8cGF0aCBkPSJNMCwwSDEwOEw2MCw0OFY3Mkg0OFY0OHoiIGZpbGw9IiNmZmYiLz4KPGNpcmNsZSBjeD0iNTQiIGN5PSIzMCIgcj0iOCIgZmlsbD0iI2Y5ZDkwZiIvPgo8cGF0aCBkPSJNNDQsMzBINjRMNTQsNDh6IiBmaWxsPSIjZmZmIi8+CjxwYXRoIGQ9Ik01NCw0OCAzOCwzM0g3MHoiIGZpbGw9IiNjZjE0MmIiLz4KPC9zdmc+";
export {
  I as default
};
//# sourceMappingURL=MF-f619aa39.mjs.map
